import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services';

@Component({
  selector: 'app-index',
  standalone: false,
  templateUrl: './index.html',
  styleUrls: ['./index.css'],
})
export class Index implements OnInit {
  validating = true;
  statusMessage = 'Verifying your session…';

  constructor(
    private auth: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (!this.auth.hasValidSession()) {
      void this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    this.auth.validateSession().subscribe({
      next: (valid) => {
        this.validating = false;
        void this.router.navigate(valid ? ['/dashboard'] : ['/login'], { replaceUrl: true });
        this.cdr.detectChanges();
      },
      error: () => {
        this.validating = false;
        void this.router.navigate(['/login'], { replaceUrl: true });
        this.cdr.detectChanges();
      },
    });
  }
}
